export default __webpack_public_path__ + "static/media/carmelKlein.6f7c10a1.jpg";